import { render, staticRenderFns } from "./sectionItemFifth.vue?vue&type=template&id=ae1978e6&scoped=true"
import script from "./sectionItemFifth.vue?vue&type=script&lang=ts"
export * from "./sectionItemFifth.vue?vue&type=script&lang=ts"
import style0 from "./sectionItemFifth.vue?vue&type=style&index=0&id=ae1978e6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae1978e6",
  null
  
)

export default component.exports